class OneDreh extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bereit) return;
    this.dataset.bereit = '1';
    this.start = Number(this.dataset.start) || 0;
    this.stufen = [...this.querySelectorAll('.one-dreh__stufe')];
    this.anzahl = this.stufen.length + 1;
    this.aktuell = this.start;

    this.tasten = [...this.querySelectorAll('.one-dreh__taste')];
    this.tastenSync();
    if (window.matchMedia && matchMedia('(pointer: coarse)').matches) return;

    let x0 = null;
    let k0 = 0;
    let bewegt = false;

    this.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      x0 = e.clientX;
      k0 = this.aktuell;
      bewegt = false;
      this.setPointerCapture(e.pointerId);
      this.classList.add('is-zieht');
      this.stufen.forEach((bild) => (bild.loading = 'eager'));
      e.stopPropagation();
    });
    this.addEventListener('pointermove', (e) => {
      if (x0 == null) return;
      const dx = e.clientX - x0;
      if (Math.abs(dx) > 4) bewegt = true;
      if (!bewegt) return;
      const schritt = Math.max(40, this.clientWidth / 7);
      this.zeige(k0 - Math.round(dx / schritt));
      e.preventDefault();
      e.stopPropagation();
    });
    const ende = (e) => {
      if (x0 == null) return;
      x0 = null;
      this.classList.remove('is-zieht');
      e.stopPropagation();
      if (bewegt) {
        const sperre = (k) => {
          k.stopImmediatePropagation();
          k.preventDefault();
        };
        window.addEventListener('click', sperre, { capture: true, once: true });
        setTimeout(() => window.removeEventListener('click', sperre, { capture: true }), 300);
      }
    };
    this.addEventListener('pointerup', ende);
    this.addEventListener('pointercancel', ende);
    ['touchstart', 'touchmove', 'mousedown'].forEach((typ) =>
      this.addEventListener(typ, (e) => e.stopPropagation(), { passive: true })
    );
  }

  tastenSync() {
    (this.tasten || []).forEach((t) => {
      const r = Number(t.dataset.dreh);
      t.disabled = r < 0 ? this.aktuell <= 0 : this.aktuell >= this.anzahl - 1;
    });
  }

  zeige(k) {
    this.aktuell = Math.max(0, Math.min(this.anzahl - 1, k));
    this.stufen.forEach((bild) => (bild.loading = 'eager'));
    this.classList.add('is-gedreht');
    this.classList.toggle('is-start', this.aktuell === this.start);
    const ziel = this.aktuell < this.start ? this.aktuell : this.aktuell - 1;
    this.stufen.forEach((bild, j) => bild.classList.toggle('is-an', this.aktuell !== this.start && j === ziel));
    this.tastenSync();
  }
}

if (!customElements.get('one-dreh')) customElements.define('one-dreh', OneDreh);

if (!window.__oneDrehTasten) {
  window.__oneDrehTasten = true;
  let sperreBis = 0;
  const drehen = (t) => {
    const d = t.closest('one-dreh');
    if (d && d.zeige && !t.disabled) d.zeige(d.aktuell + Number(t.dataset.dreh));
  };
  window.addEventListener(
    'pointerup',
    (e) => {
      const t = e.target.closest && e.target.closest('.one-dreh__taste');
      if (!t) return;
      sperreBis = Date.now() + 600;
      e.stopImmediatePropagation();
      drehen(t);
    },
    true
  );
  window.addEventListener(
    'click',
    (e) => {
      const t = e.target.closest && e.target.closest('.one-dreh__taste');
      if (!t && Date.now() > sperreBis) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      if (t && e.detail === 0) drehen(t);
    },
    true
  );
}
